import './styles/component.account-form.scss';
import { isNullOrUndef } from '../js/helpers/isNullOrUndef';
import { _qs, _qsa, _on, _data, _cel, _html, _text } from '../js/shortJS';
import { isNotNullOrUndef } from '../js/helpers/isNotNullOrUndef';
import { dlLoginSuccessEvent } from '../events/login/dl.login.success.event';
import { dlRegistrationErrorEvent } from '../events/registration/dl.registration.error.event';
import { dlRegistrationSuccessEvent } from '../events/registration/dl.registration.success.event';
class ComponentAccountForm extends HTMLElement {
    form;
    nameField;
    emailField;
    passwordField;
    submitBtn;
    errorWrapper;
    autologin = false;
    parser = new window.DOMParser();
    connectedCallback() {
        const form = this[_qs]('form');
        if (isNullOrUndef(form))
            return;
        const nameField = form[_qs]('[name="customer[first_name]"]');
        const emailField = form[_qs]('[name="customer[email]"]');
        const passwordField = form[_qs]('[name="customer[password]"]');
        const submitBtn = form[_qs]('[type="submit"]');
        if (isNullOrUndef(submitBtn) ||
            isNullOrUndef(nameField) ||
            isNullOrUndef(emailField) ||
            isNullOrUndef(passwordField))
            return;
        this.form = form;
        this.submitBtn = submitBtn;
        this.nameField = nameField;
        this.emailField = emailField;
        this.passwordField = passwordField;
        this.errorWrapper = this[_qs]('[data-form-error]');
        this.init();
    }
    init() {
        this.form[_on]('submit', this.submitHandler.bind(this));
        this[_qsa]('[data-mode-changer]').forEach(changer => {
            changer[_on]('click', this.toggleMode.bind(this));
        });
    }
    get endpoint() {
        return this.mode !== 'login' && !this.autologin ? '/account' : '/account/login';
    }
    set status(value) {
        this[_data].status = value;
    }
    get status() {
        return this[_data].status ?? 'default';
    }
    set mode(value) {
        this[_data].mode = value;
    }
    get mode() {
        return this[_data].mode ?? 'registration';
    }
    toggleMode() {
        this.mode = this.mode !== 'login' ? 'login' : 'registration';
        this.nameField.required = !this.nameField.required;
        this.nameField.hidden = !this.nameField.hidden;
    }
    submitHandler(event) {
        isNotNullOrUndef(event) && event.preventDefault();
        this.status = 'loading';
        const formData = this.mode !== 'login' && !this.autologin
            ? 'form_type=create_customer' +
                '&utf8=' + encodeURIComponent('✓') +
                '&customer[first_name]=' + encodeURIComponent(this.nameField.value) +
                '&customer[email]=' + encodeURIComponent(this.emailField.value) +
                '&customer[password]=' + encodeURIComponent(this.passwordField.value) +
                '&customer[tags]=' + encodeURIComponent('Wishlist account')
            : 'form_type=customer_login' +
                '&utf8=' + encodeURIComponent('✓') +
                '&customer[email]=' + encodeURIComponent(this.emailField.value) +
                '&customer[password]=' + encodeURIComponent(this.passwordField.value);
        const xhr = new window.XMLHttpRequest();
        xhr.onload = this.successHandler.bind(this, xhr);
        xhr.onerror = this.errorHandler.bind(this);
        xhr.open('POST', this.endpoint, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.send(formData);
    }
    successHandler(xhr) {
        if (xhr.status !== 200) {
            this.status = 'error';
            return;
        }
        const parseDom = this.parser.parseFromString(xhr.responseText, 'text/html');
        const errors = parseDom[_qs]('form .errors');
        if (isNotNullOrUndef(errors)) {
            if (isNotNullOrUndef(this.errorWrapper)) {
                this.status = 'default';
                this.errorWrapper[_html] = errors[_html];
                this.errorWrapper.hidden = false;
            }
            const errorText = errors[_text];
            if (this.mode === 'registration' &&
                !this.autologin &&
                errorText?.includes('verify your email address') !== true) {
                dlRegistrationErrorEvent(this.nameField.value, null, this.emailField.value, errorText);
            }
            return;
        }
        const successEvent = new CustomEvent('success', {
            detail: {
                name: this.nameField.value,
                email: this.emailField.value
            }
        });
        this.dispatchEvent(successEvent);
        this.status = 'success';
        document.cookie = `customerEmail=${this.emailField.value}; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT; sameSite=lax;`;
        if (this.mode === 'registration' && !this.autologin) {
            dlRegistrationSuccessEvent({
                email: this.emailField.value,
                firstName: this.nameField.value
            });
            this.autologin = true;
            this.submitHandler();
            return;
        }
        this.autologin = false;
        const dataEl = parseDom[_qs]('#template__wishlist-customer');
        if (isNullOrUndef(dataEl))
            return;
        const newCustomerData = JSON.parse(dataEl[_html]);
        window.customer.id = newCustomerData.customerId;
        window.customer.firstName = newCustomerData.customerFirstName ?? '';
        window.customer.email = newCustomerData.customerEmail;
        window.customer.wishlistItemHandles = newCustomerData.itemHandles;
        if (newCustomerData.acceptMarketing !== false) {
            window.customer.accept_marketings = true;
            document.cookie = 'customerAM=true; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT; sameSite=lax;';
        }
        const userBlock = document[_cel]('div');
        let userName = (isNotNullOrUndef(newCustomerData.customerFirstName) && newCustomerData.customerFirstName.length > 0
            ? newCustomerData.customerFirstName
            : newCustomerData.customerEmail).substring(0, 6);
        if (isNotNullOrUndef(newCustomerData.customerFirstName) && newCustomerData.customerFirstName.length > 7) {
            userName += '...';
        }
        userBlock[_html] = `<p>HELLO</p><span>${userName}</span>`;
        const desktopAcc = document[_qs]('.sh__icons a[href*="account/login"]');
        isNotNullOrUndef(desktopAcc) && desktopAcc.append(userBlock);
        document[_qsa]('a[href*="account/login"]').forEach(elem => {
            elem.href = '/account';
        });
        const mobileAcc = document[_qs]('.mob-menu_account_items');
        if (mobileAcc !== null) {
            mobileAcc[_html] = `<li>
          <a href="/account"
             class="fw:700"
             data-ga-event='["Nav : mobile", "click", "Account"]'
             aria-label="Account"
             aria-describedby="adb_open adb_word-page">${String(newCustomerData.customerFirstName ?? '')}</a>
        </li>`;
        }
        document[_qsa]('.ss__wishlist_registration').forEach(elem => {
            elem.hidden = true;
        });
        document[_qsa]('.sh__account_dd').forEach(elem => {
            elem.hidden = true;
        });
        dlLoginSuccessEvent({ email: newCustomerData.customerEmail, id: newCustomerData.customerId });
    }
    errorHandler() {
        this.status = 'error';
    }
}
customElements.define('account-form-component', ComponentAccountForm);
